// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"e8846ef5","213":"2a00fc11","453":"8a850d97","455":"cbb4bdbe"}[chunkId] + ".chunk.js";
};